export const convertBase64ToFileAndView = (base64String:string, fileType:string, fileName = 'kararlar') => {
    if (!base64String) {
        // base64String boş ise, false döndür
        return false;
    }
  
    // Base64 verisinden byte dizisini oluştur
    const binaryString = window.atob(base64String);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
  
    for (let i = 0; i < binaryLen; i++) {
        const ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
    }
  
    // Blob'u oluştur
    const blob = new Blob([bytes], { type: fileType }); // fileType'i kullan
    const url = window.URL.createObjectURL(blob);
  
    // Yeni sekmede görüntüleme işlemini gerçekleştir
    const viewLink = document.createElement('a');
    viewLink.href = url;
    viewLink.target = '_blank'; // Yeni sekmede aç
    viewLink.download = `${fileName}.${fileType.split('/')[1]}`; // Dosya adını belirle
    document.body.appendChild(viewLink);
    viewLink.click();
    document.body.removeChild(viewLink);
  
    // base64String dolu ise, true döndür
    return true;
  };